export * from './config';

export {
  getMenuByLocale,
  getHeaderVariantByLocale,
  getFooterVariantByLocale,
  getLogoVariantByLocale,
  getGlobalLogoVariant,
} from './menu';

export { getRegisterTypeByLocale, getRegisterTypeByDomain, getRegisterTypeByIdentity } from './register';

export { isDomainHasIdentityConfig } from './domain';
